export default "__VITE_ASSET__f74e92b9__"